import { ReactElement, useState } from 'react';
import CcxComponentProps from '../../core/CcxComponent';

import styles from './AccountSecurity.module.less';
import { Authorization } from './authorization/Authorization';
import AppBorderedPanel from '../ccx/common/AppBorderedPanel';
import { Row, Col, Space, Button } from 'antd';
import ChangePasswordModal from './accountInfo/ChangePasswordButton';

export type ChangePassword = {
    oldPassword: string;
    newPassword: string;
};

export type PasswordError = {
    visible: boolean;
    message: string;
};

export interface ChangePasswordFormInterface extends ChangePassword {
    confirmPassword: string;
}

function AccountSecurity({
    testId = 'AccountSecurity',
}: CcxComponentProps): ReactElement {
    return (
        <div className={styles.AccountSecurity} data-testid={testId}>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Authorization />
                </Col>
                <Col span={24}>
                    <div>
                        <h1 data-testid={`${testId}AccountManagementTitle`}>
                            <strong>Authentication</strong>
                        </h1>

                        <AppBorderedPanel>
                            <Row justify={'space-between'} align={'middle'}>
                                <Col>
                                    <Space direction="vertical" size="middle">
                                        <div>
                                            <strong>Change password</strong>
                                            <br />
                                            Make your account more secure by
                                            changing your password at least once
                                            every three months.{' '}
                                        </div>
                                    </Space>
                                </Col>

                                <Col sm={4} xs={24}>
                                    <Space direction="vertical" size="middle">
                                        <ChangePasswordModal />
                                    </Space>
                                </Col>
                            </Row>
                        </AppBorderedPanel>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default AccountSecurity;
